import { connect } from "react-redux";
import { compose } from "redux";

import { getCompetitionMatches } from "./actions";
import { CompetitionResults as Component } from "./competitionResults";
import {
  makeSelectCompetitionMatches,
  makeSelectIsError,
  makeSelectIsReady,
  makeSelectNextPage,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectCompetitionMatches = makeSelectCompetitionMatches();
  const selectNextPage = makeSelectNextPage();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    matches: selectCompetitionMatches(state, ownProps),
    nextPage: selectNextPage(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetCompetitionMatches: (data) => dispatch(getCompetitionMatches(data)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
